import { Survey } from './survey';
import { EmailList } from './email-list';

export class SurveyInvitation {

  id: number; // (read-only field)
  survey: string; // url of the survey (read-only field)
  created: string; // (read-only field)
  updated: string; // (read-only field)
  deleted: string; // (read-only field)
  subject: string;
  sender: string;
  body: string;
  delivery_time: string;
  content_type: string = 'text/plain';
  is_reminder: boolean = false;
  state: string; // state of the invitation (read-only field)
  state_pretty: string; // pretty version of state of the invitation (read-only field)
  owner: string; // url of the invitation user (read-only field)
  email_lists: any;

  public static contentTypes = [
    {value: 'text/plain', display: 'Plain Text'},
    {value: 'text/html', display: 'HTML'}
  ];

  private _survey: Survey;

  getSurvey(): Survey {
    return this._survey;
  }

  setSurvey(survey: Survey) {
    this._survey = survey;
  }

  private _email_lists: EmailList[] = [];

  getEmailLists(): EmailList[] {
    return this._email_lists;
  }

  setEmailLists(email_lists: EmailList[]) {
    this._email_lists = email_lists;
  }


  /*

  Example of survey invitation payload
  {
    "id": 1,
    "survey": "http://127.0.0.1:8000/api/v1/surveys/180/",
    "created": "2017-10-02T08:08:26.577060Z",
    "updated": "2017-10-02T08:08:26.577108Z",
    "deleted": null,
    "subject": "Gästundersökning subject",
    "sender": "info@gena.se",
    "body": "invitation text",
    "delivery_time": "2017-11-11T10:00:00Z",
    "content_type": "text/html",
    "is_reminder": false,
    "owner": "http://127.0.0.1:8000/api/v1/users/1/"
  }

  */

  toJSON(): Object {
    // create an instance of the SurveyInvitation class
    let survey_invitation = Object.create(SurveyInvitation.prototype);
    // copy all the fields from the json object
    survey_invitation.subject = this.subject;
    survey_invitation.sender = this.sender;
    survey_invitation.body = this.body;
    survey_invitation.delivery_time = this.delivery_time;
    survey_invitation.content_type = this.content_type;
    survey_invitation.is_reminder = this.is_reminder;

    return survey_invitation;
  }


  static fromJSON(survey_invitation_json: any): SurveyInvitation {

    // create an instance of the SurveyLink class
    let survey_invitation = Object.create(SurveyInvitation.prototype);
    // copy all the fields from the json object
    let obj = Object.assign(survey_invitation, survey_invitation_json, {
      // fixme this conversion block may even be not used!
      // convert fields that need converting
      //created: new Date(survey_link_json.created),
      //activated: new Date(survey_link_json.activated),
      //deactivated: new Date(survey_link_json.deactivated),
      //deleted: new Date(survey_link_json.deleted),

    });

    let email_lists_json = survey_invitation.email_lists;
    let _email_lists: EmailList[] = [];
    for (let email_list_json of email_lists_json) {
      let email_list = EmailList.fromJSON(email_list_json);
      _email_lists.push(email_list);
    }
    survey_invitation.setEmailLists(_email_lists);
    delete survey_invitation.email_lists;
    return survey_invitation;

  }
}

